import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'numberPipe',
  standalone: true
})
export class NumberPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) {}

  transform(
    value: number | string,
    digitsInfo: string = '1.0-6',
    locale: string = 'es-CL'
  ): string | null {

    if (value === null || value === undefined) {
      return null;
    }

    return this.decimalPipe.transform(value, digitsInfo, locale);
  }
}